import { Injectable } from '@angular/core';
import { WinRT } from '@lenovo/tan-client-bridge-le';
import { DeviceService } from '../device/device.service';

@Injectable({
	providedIn: 'root',
})
export class CardService {
	constructor(public deviceService: DeviceService) {}

	linkClicked(actionType: string, actionLink: string, isOfflineArm?: boolean) {
		if (isOfflineArm) {
			return false;
		}

		const isProtocol = actionLink.startsWith('lenovo-vantage3:');

		if (isProtocol || actionType === 'External') {
			WinRT.launchUri(actionLink);
		}

		if (!actionType || (actionType !== 'Internal' && !isProtocol)) {
			return;
		}

		return false;
	}
}

export const CardOverlayTheme = {
	Default: 'default',
	Light: 'light',
	Dark: 'dark',
};
